import { cn } from "@/utils/cn"
import { CheckIcon } from "lucide-react"
import { ReactNode } from "react"

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: ReactNode
  className?: string
}
export function Checkbox({
  label,
  checked,
  onChange,
  className,
}: CheckboxProps) {
  return (
    <label className={cn("flex cursor-pointer items-center gap-2", className)}>
      <div
        className={cn(
          "relative flex h-4 w-4 items-center justify-center rounded-xs border border-primary-500 bg-neutral-light transition-all duration-300 focus-within:ring-[1px] focus-within:ring-primary-500",
          checked && "bg-green-500"
        )}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="absolute inset-0 cursor-pointer opacity-0"
        />
        {checked && <CheckIcon className="h-3 w-3 text-primary-500" />}
      </div>
      <span className="font-family-gtpressura text-md font-light text-neutral-dark">
        {label}
      </span>
    </label>
  )
}
